import update from 'immutability-helper'
import { StoreActionMap } from '@/store/types'

export interface InsurancesReducer {
  insurancesAttempts: Record<string, number>
}

export const initialInsurancesReducerState: InsurancesReducer = {
  insurancesAttempts: {},
}

export enum InsurancesTypes {
  Restore = 'Insurances/RESTORE',
  SetInsuranceAttempt = 'Insurances/SET_INSURANCE_ATTEMPT',
  Clean = 'Insurances/CLEAN',
}

type InsurancesPayload = {
  [InsurancesTypes.Restore]: InsurancesReducer
  [InsurancesTypes.SetInsuranceAttempt]: { insuranceId: string; attempt: number }
  [InsurancesTypes.Clean]: null
}

export type InsurancesActions = StoreActionMap<InsurancesPayload>[keyof StoreActionMap<InsurancesPayload>]

const insurancesReducer = (curState: InsurancesReducer, action: InsurancesActions): InsurancesReducer => {
  switch (action.type) {
    case InsurancesTypes.Restore:
      return {
        ...action.payload,
      }
    case InsurancesTypes.SetInsuranceAttempt:
      const { insuranceId, attempt } = action.payload
      return update(curState, {
        insurancesAttempts: {
          [insuranceId]: { $set: attempt },
        },
      })
    case InsurancesTypes.Clean:
      return initialInsurancesReducerState
    default:
      return curState
  }
}

export default insurancesReducer
